import { Field } from 'redux-form';

import { addressOneLine } from 'common/components/address/helpers';
import { SelectField } from 'common/components/forms';

const AddressPicker = (props) => {
  const { customerAddresses, onAddressChange } = props;
  if (!customerAddresses) {
    return null;
  }
  const addressArrayIds = Object.keys(customerAddresses);
  const addressArray = addressArrayIds.map(
    (addressId) => customerAddresses[addressId]
  );
  if (addressArray.length > 0) {
    return (
      <Field
        name="customerAddressId"
        component={SelectField}
        optionArray={addressOptionArray(addressArray)}
        label="Address"
        onChange={onAddressChange}
        required
      />
    );
  }
  return null;
};

export default AddressPicker;

const addressOptionArray = (addresses) => {
  const array = [];
  array.push({ option: 'New Address', value: '' });
  addresses.forEach((address) => {
    array.push({ option: addressOneLine(address), value: address.id });
  });
  return array;
};
